module.exports = __webpack_public_path__ + "static/assets/c0c7d5c3196e1373d5de5b111f2d77ad.svg";